DW.ContactMenu = function(menu, menuToggles) {
	this.menu = menu;
	this.menuToggles = [].slice.call(menuToggles);
	var i;

	this.menuToggles.forEach(function(menuToggle) {
		menuToggle.addEventListener('click', this.toggleMenu.bind(this));
	}.bind(this));
};

DW.ContactMenu.prototype.toggleMenu = function(ev) {
	ev.preventDefault();
	this.menu.classList.toggle('active');
	this.menuToggles.forEach(function(menuToggle) {
		menuToggle.classList.toggle('active');
	});
};
